function setError(msg) {
  console.error(msg)
  var error = document.getElementById('error');
  error.innerHTML = msg;
}

export { setError }
